import { IoCodeSlashOutline } from "react-icons/io5";
import { CiServer } from "react-icons/ci";
import { PiDatabaseThin } from "react-icons/pi";
import { CiGrid42 } from "react-icons/ci";
import { VscTools } from "react-icons/vsc";

import eventique from '../assets/Eventique_project.png';
import car_accident from '../assets/us_car_accident.png';
import natours from '../assets/Natours.png';

const skillIconClass = 'w-6 h-6 md:w-8 md:h-8'

export const RESUME_LINK = 'https://drive.google.com/file/d/1bRUYbyM1l4iosXiC2uzWfDfdxve1Oj7A/view?usp=drivesdk'

export const SKILLS = [
  {
    category: 'languages',
    icon: <IoCodeSlashOutline className={skillIconClass}/>,
    values: ['java', 'python', 'javascript', 'Bash', 'SQL' ]
  },
  {
    category: 'backend',
    icon: <CiServer className={skillIconClass}/>,
    values: ['spring boot', 'Spring MVC', 'Hibernate', 'microservices', 'RabbitMq', 'REST API', 'nodejs', 'expressjs']
  },
  {
    category: 'databases',
    icon: <PiDatabaseThin className={skillIconClass}/>,
    values: ['mySql', 'postgres', 'mongoDB', 'redis', 'TimescaleDB']
  },
  {
    category: 'tools & methodologies',
    icon: <VscTools className={skillIconClass}/>,
    values: ['git', 'jira', 'agile', 'vscode', 'eclipse', 'postman', 'Intellij', 'docker', 'AWS', 'CI/CD']
  },
  {
    category: 'frontend',
    icon: <CiGrid42 className={skillIconClass}/>,
    values: ['reactjs','tailwind CSS', 'jquery', 'CSS3', 'html']
  },
  
]

export const EXPERIENCES = [
  {
    year: 'Aug 2024 - Present',
    role: 'Software Engineer Intern',
    company: 'Copart Inc.',
    location: 'Dallas, TX',
    description: `Contributing to Copart's B2B seller integrations by building scalable microservices, integrating forecasting 
    models to minimize SLA breaches, optimizing Redis storage & improving inter-service communication using Apache Camel, to mention a few.`,
    technologies: [
      'Microservices',
      'Apache Camel',
      'Spring Boot',
      'Postgres/MariaDB',
      'Machine learning',
      'Python',
      'Java',
      'REST APIs'
    ]
  },
  {
    year: 'Oct 2022 - Aug 2023',
    role: 'Software Engineer',
    company: 'Opentext Technologies',
    location: 'India',
    description: `Enhanced Content Hub for Publishers by resolving 200+ issues and delivering 30+ features, contributing to 
    $800K+ annual revenue. Improved fault tolerance of third-party API integrations using Resilience4j and added support for importing assets from multiple vendors.`,
    technologies: [
      'Java',
      'Spring Boot',
      'Javascript',
      'AWS',
      'HTML/CSS',
      'Shell scripting',
    ],
  },
  {
    year: 'Aug 2020 - Sept 2022',
    role: 'Associate Software engineer',
    company: 'Opentext Technologies',
    location: 'India',
    description: `Worked with security and QA teams to ensure smooth product releases. Resolved 30+ critical security issues and 
    led end-to-end implementation of a password encryption mechanism, significantly strengthening user data protection.`,
    technologies: ['Javascript', 'Java', 'Spring Boot', 'HTML/CSS', 'Shell scripting'],
  }
];

export const PROJECTS = [
  {
    title: 'Eventique - AI enhanced event planning',
    image: eventique,
    gitlink: `https://github.com/Govind-Asawa/eventique`,
    description: `A full-stack web application that leverages Large Language model (LLM) service to generate plans for an event. Integrated calendar to visualize user's tasks for an event generated by LLM.`,
    technologies: [
      'React.js',
      'tailwindCSS',
      'Django',
      'Gemini-pro',
      'postgreSql',
      'GCP',
      'CI/CD',
    ],
  },
  {
    title: 'US car accidents',
    image: car_accident,
    gitlink: `https://github.com/Govind-Asawa/US_Car_Accidents`,
    description:
      'Churned 7.7 million records, achieving 87% accuracy in predicting the severity level of car accidents in the USA by analyzing various factors contributing to the accidents, such as weather conditions, road features (like road crossings, junctions, signals), time and location, etc.',
    technologies: ['python', 'Data Analysis', 'Machine Learning'],
  },
  {
    title: 'Natours - Book your tour',
    image: natours,
    gitlink: `https://github.com/Govind-Asawa/natours-app`,
    description:
      'A Web-app for users to browse through available tour packages, view and book tours using secure payment method.',
    technologies: [
      'Node.js',
      'express.js',
      'HTML',
      'CSS',
      'javascript',
      'pug',
      'MongoDB',
    ],
  },
];
